function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHomeRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3L2 17h4v10a2 2 0 002 2h3.5v-6.087A2.917 2.917 0 0114.413 20h3.174a2.917 2.917 0 012.913 2.913V29H24a2 2 0 002-2V17h4L16 3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.587 22h-3.174a.913.913 0 00-.913.913V29h5v-6.087a.913.913 0 00-.913-.913z",
    fill: props.color
  }));
}

export default SvgIconHomeRexFilled;